export default {
  today: {
    id: 'track_parcel_today',
    defaultMessage: 'Today',
  },
  singleDeliveryDate: {
    id: 'track_parcel_single_delivery_date',
    defaultMessage: '{weekday}, {date}',
  },
  sameMonthDeliveryDateRange: {
    id: 'track_parcel_same_month_delivery_date_range',
    defaultMessage: '{month} {day1} - {day2}',
  },
  splitMonthDeliveryDateRange: {
    id: 'track_parcel_split_month_delivery_date_range',
    defaultMessage: '{date1} - {date2}',
  },
}
